import { useState, useEffect, useCallback } from "react";
import Sidebar from "../../sidebar/sidebar";
import TopBar from "../../topbar/TopBar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { getDeptListApi, getEditApi, getFieldListApi, getfielsApi, getGateListApi, getOptionsListApi, registerSubmitApi, UpdateFieldsApi } from "./registerfield-api";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import { get } from "../../../services/apiService";
import AsyncSelect from "react-select/async";
import { TbFlagSearch } from "react-icons/tb";
import PoweredBy from "../../common/poweredBy";

const Registerfieldsadd = () => {
  //useLocation
  const location = useLocation();
  const { id } = location.state || {};

  const [activeTab, setActiveTab] = useState("Visitor");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [fieldOptions, setfieldOptions] = useState([]);
  const [fieldName, setFieldName] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [name, setName] = useState("");
  const [code, setCode] = useState("");

  const [validations, setValidations] = useState({
    code: "",
    name: "",
    visitor_fields: "",
    vehicle_fields: "",
  });

  // const handleToggle = (option) => {
  //   const updatedFields = fieldOptions.map((field) => (field.field_name === option.field_name ? { ...field, enabled: !field.enabled } : field));

  //   setfieldOptions(updatedFields);
  // };
  // const handleMandToggle = (option) => {
  //   const updatedFields = fieldOptions.map((field) => (field.field_name === option.field_name ? { ...field, mandatory: !field.mandatory } : field));

  //   setfieldOptions(updatedFields);
  // };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const submitform = async (value) => {
    const payload = {
      code: code,
      name: name,
      gates: gate?.filter((item) => item.value !== "").map((item) => item.value),
      departments: department?.filter((item) => item.value !== "").map((item) => item.value),
      visitor_fields: visitorOptions,
      vehicle_fields: vehicleOptions,
    };
    let response;
    if (id != null) {
      response = await UpdateFieldsApi(payload, id);
      navigate("/registerfields");
    } else {
      response = await registerSubmitApi(payload);
    }
    console.log(response, "response");
    console.log("response.status", response.status);

    if (response.status === true) {
      setSnackbarMessage(response.message);
      setSnackbarStatus(response.status);
      handleSnackbarShow();
      navigate("/registerfields");

      setValidations({
        code: "",
        name: "",
        visitor_fields: "",
        vehicle_fields: "",
      });
    }

    if (response.status === false) {
      const validationErrors = response.error || {};
      const validationTemp = {
        code: validationErrors.code || "",
        name: validationErrors.name || "",
        visitor_fields: validationErrors.visitor_fields || "",
        vehicle_fields: validationErrors.vehicle_fields || "",
      };
      setValidations(validationTemp);
      console.log("validations", validations);
    }
  };

  useEffect(() => {
    if (id != null) {
      getFieldsDetails();
    } else {
      getOptionData(activeTab);
    }
  }, []);

  const getFieldsDetails = async () => {
    try {
      const response = await getEditApi(id);
      console.log(response);
      if (response.status === true || response.config != null) {
        const config = response.config; // Get the first call

        setCode(config.code);
        setName(config.name);
        setGate(config.gates);
        setDepartment(config.departments);

        setVisitorOptions(
          (config.visitor_fields || []).map((field) => ({
            ...field,
            enabled: !!field.enabled,
            mandatory: !!field.mandatory,
          }))
        );

        setVehicleOptions(
          (config.vehicle_fields || []).map((field) => ({
            ...field,
            enabled: !!field.enabled,
            mandatory: !!field.mandatory,
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching call details:", err);
    }
  };
  const navigate = useNavigate();

  //Gate
  const [gate, setGate] = useState([]);
  const fetchGate = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getGateListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleGateChange = (selectedOptions) => {
    setGate(selectedOptions);
  };

  //Department
  const [department, setDepartment] = useState([]);
  const fetchDepartment = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching department options with term:", inputValue);
      const response = await getDeptListApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };

  const handleDepartmentChange = (selectedOptions) => {
    setDepartment(selectedOptions);
  };

  const getListData = async () => {
    try {
      const response = await getFieldListApi();
      if (response.data.success === true) {
        setFieldName(response.data.suggestionlist.map((item) => item.value));
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [options, setOptions] = useState([]);
  const [visitorDataFetched, setVisitorDataFetched] = useState(false);
  const [vehicleDataFetched, setVehicleDataFetched] = useState(false);


  const getOptionData = async (tab) => {
    try {
      const response = await getOptionsListApi(tab);
      if (response.data.success === true) {
        const transformed = response.data.fields.map((field) => ({
          field_name: field.field_name || field, // adapt to API shape
          enabled: field.enabled ?? false,
          mandatory: field.mandatory ?? false,
        }));

        if (tab === "Visitor" && !visitorDataFetched) {
          setVisitorOptions(transformed);
          setVisitorDataFetched(true);
        } else if (tab === "Vehicle" && !vehicleDataFetched) {
          setVehicleOptions(transformed);
          setVehicleDataFetched(true);
        }
      }
    } catch (err) {
      console.error("Error fetching fields:", err);
    }
  };

  // const getFields = async (value) => {
  //   try {
  //     const response = await getfielsApi(value);
  //     console.log("fields");
  //     console.log(response);
  //     if (response.success === true) {
  //       setfieldOptions([]);
  //       console.log("fieldOptions test", fieldOptions);
  //       setfieldOptions(response.fields);
  //       console.log("fieldOptions test", fieldOptions);
  //     }
  //   } catch (err) {
  //     console.error("Error fetching category:", err);
  //   } finally {
  //   }
  // };

  useEffect(() => {
    getListData();
    //getFields(activeTab);
  }, []);

  //Toggle and mandatory toggle

  const handleToggle = (selectedOption) => {
    const update = (list) => list.map((opt) => (opt.field_name === selectedOption.field_name ? { ...opt, enabled: !opt.enabled, mandatory: false } : opt));

    if (activeTab === "Visitor") {
      setVisitorOptions((prev) => update(prev));
    } else {
      setVehicleOptions((prev) => update(prev));
    }
  };

  const handleMandToggle = (selectedOption) => {
    const update = (list) => list.map((opt) => (opt.field_name === selectedOption.field_name ? { ...opt, mandatory: !opt.mandatory } : opt));

    if (activeTab === "Visitor") {
      setVisitorOptions((prev) => update(prev));
    } else {
      setVehicleOptions((prev) => update(prev));
    }
  };

  const [visitorOptions, setVisitorOptions] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([]);

  return (
    <div style={{ fontFamily: "Epilogue" }}>
      <div>
        <TopBar />
      </div>
      <div style={{ display: "flex" }}>
        <div>
          <Sidebar activeMenu={"Register Fields"} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "20px", backgroundColor: "#FFFFFF" }}>
          <div style={{ marginBottom: "40px" }}>
            <Row className="align-items-center" style={{ marginBottom: "32px" }}>
              <Col xs={12} md={6}>
                <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Create new template</div>
              </Col>
              <Col xs={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap" }}>
                  <button style={{ borderRadius: "10px", height: "44px", border: "1px solid #e5e5e5", padding: "10px 32px", backgroundColor: "#ffffff", fontWeight: "700", fontSize: "14px", color: "#172b4d", cursor: "pointer" }} onClick={() => navigate("/registerfields")}>
                    Cancel
                  </button>
                  <button onClick={() => submitform()} style={{ borderRadius: "10px", border: "none", height: "44px", padding: "10px 32px", backgroundColor: "#2c8c53", fontWeight: "700", fontSize: "14px", color: "#ffffff", cursor: "pointer" }}>
                    Save
                  </button>
                </div>
              </Col>
            </Row>

            <Row className="align-items-center" style={{ width: "100%" }}>
              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                    Code <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input type="text" placeholder="Enter code" value={code} onChange={(e) => setCode(e.target.value)} style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#8790A1", width: "100%" }} />
                    <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.code}</span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
                    Template Name <span style={{ color: "#ff4444" }}>*</span>
                  </div>
                  <div>
                    <input value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Enter code" style={{ border: "1.3px solid #E5E5E5", borderRadius: "10px", padding: "16px", height: "40px", backgroundColor: "#ffffff", fontWeight: "400", fontSize: "13px", color: "#8790A1", width: "100%" }} />
                    <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.name}</span>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>Gate</div>
                  <div>
                    <AsyncSelect isMulti cacheOptions value={gate} loadOptions={fetchGate} onChange={handleGateChange} defaultOptions placeholder="Search gate..." styles={multiselectCustomStyles} isClearable={false} />
                  </div>
                </div>
              </Col>

              <Col sm={12} md={6} lg={3}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>Department</div>
                  <div>
                    <AsyncSelect isMulti cacheOptions value={department} loadOptions={fetchDepartment} onChange={handleDepartmentChange} defaultOptions placeholder="Search department..." styles={multiselectCustomStyles} isClearable={false} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", padding: "16" }}>
            <div>
              <div style={{ fontWeight: "700", fontSize: "20px", color: "#172b4d" }}>Register Fields</div>
              <div>
                <div style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86" }}>
                  {/* <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px", visibility: "hidden" }}></div> */}
                  <div style={{ borderRadius: "8px", visibility: "hidden" }}>Visitor gate-in</div>
                </div>
                {fieldName.map((label) => (
                  <div
                    key={label}
                    style={{ display: "flex", alignItems: "center", borderLeft: "1px dashed #626F86", cursor: "pointer" }}
                    onClick={() => {
                      setActiveTab(label);
                      if (id == null) {
                        getOptionData(label);
                      }

                    }}>
                    <div style={{ border: "1px dashed #626F86", width: "20px", height: "0px" }}></div>
                    <div style={{ borderRadius: "8px", padding: "10px 8px 10px 12px", backgroundColor: activeTab === label ? "#F3FFF8" : "", border: activeTab === label ? "1px dashed #2c8c53" : "", color: activeTab === label ? "#2c8c53" : "#000", transition: "all 0.2s ease-in-out", width: "100%" }}>{label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ borderRadius: "16px", padding: "20px 16px 16px 16px", backgroundColor: "#F8F8F8", display: "flex", flexDirection: "column", gap: "12px", width: "75%" }}>
              <div style={{ marginTop: "6px", fontWeight: "700", fontSize: "14px", color: "#2c8c53", textAlign: "center" }}>{activeTab.toUpperCase()}</div>

              <div>
                <div style={{ marginBottom: "12px", fontWeight: "600", fontSize: "13px", color: "#8790A1" }}>Configurations</div>

                <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.vehicle_fields}</span>

                <span style={{ fontWeight: "400", fontSize: "12px", color: "#ff4444" }}>{validations.visitor_fields}</span>

                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  {(activeTab === "Visitor" ? visitorOptions : vehicleOptions).map((option) => (
                    <div key={option.field_name} style={{ backgroundColor: "#FFFFFF", borderRadius: "6px", padding: "16px", display: "flex", flexDirection: "column", gap: "24px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ fontWeight: "600", fontSize: "14px", color: "#174b4d" }}>{option.field_name}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                          {option.enabled && (
                            <>
                              <div style={{ paddingLeft: "12px", paddingRight: "12px", borderRadius: "10px", backgroundColor: "#F8F8F8", display: "flex", alignItems: "center" }}>
                                <div style={{ padding: "4px", marginRight: "8px" }}>
                                  <input type="checkbox" checked={option.mandatory} onChange={() => handleMandToggle(option)} style={{ width: "20px", height: "20px", accentColor: "#2C8C53", cursor: "pointer", marginTop: "3px", borderRadius: "6px", transform: "scale(0.8)", outline: "1px solid #ccc" }} />
                                </div>
                                <div onClick={() => handleMandToggle(option)} style={{ fontWeight: "500", fontSize: "13.5px", cursor: "pointer", color: "#172b4d" }}>
                                  Mandatory
                                </div>
                              </div>
                              <div style={{ width: "1px", height: "28px", backgroundColor: "#E5E5E5" }}></div>
                            </>
                          )}
                          <label style={{ display: "inline-block", position: "relative", width: "40px", height: "24px" }}>
                            <input type="checkbox" checked={option.enabled} onChange={() => handleToggle(option)} style={{ opacity: 0, width: 0, height: 0 }} />
                            <span style={{ position: "absolute", cursor: "pointer", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: option.enabled ? "#2c8c53" : "#ccc", transition: ".4s", borderRadius: "24px" }}></span>
                            <span style={{ position: "absolute", height: "18px", width: "18px", left: option.enabled ? "20px" : "4px", bottom: "3px", backgroundColor: "white", transition: ".4s", borderRadius: "50%" }}></span>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div style={{ marginTop: "20px" }}>
                  {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button onClick={() => submitform()} style={{ borderRadius: "100px", border: "1px solid #E5E5E5", padding: "10px 28px", backgroundColor: "#2C8C53", fontWeight: "700", fontSize: "14px", width: "160px", color: "#FFFFFF", cursor: "pointer" }}>
                      Update
                    </button>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>
        <ToastContainer position="top-end">
          <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
            <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default Registerfieldsadd;
